import { ReactNode } from 'react';

import {
    Align,
    DirectionEnum,
    FlexBox,
    FlexItem,
    Icon,
    IconName,
    IconSize,
    Text,
    TextLevels,
    TypographyAlign,
} from '@bytel/trilogy-react';

interface PepitePropsType {
    iconName?: IconName;
    children: ReactNode;
    level?: TextLevels;
    iconSize?: IconSize;
}

export function Pepite({
    iconName,
    children,
    level = TextLevels.TWO,
    iconSize = IconSize.SMALL,
}: Readonly<PepitePropsType>) {
    return (
        <FlexItem>
            <FlexBox align={Align.CENTER} direction={DirectionEnum.ROW}>
                <FlexItem narrow>
                    <Icon name={iconName ?? IconName.CHECK} size={iconSize} />
                </FlexItem>
                <FlexItem>
                    <Text level={level} marginless typo={TypographyAlign.TEXT_LEFT} className='is-prewrap'>
                        {children}
                    </Text>
                </FlexItem>
            </FlexBox>
        </FlexItem>
    );
}
